import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiFormGroup: {
    defaultProps?: ComponentsProps['MuiFormGroup'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormGroup'];
    variants?: ComponentsVariants['MuiFormGroup'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: (props) => [
            {
                '> *:not(:first-of-type)': {
                    margin: props.ownerState.row
                        ? props.theme.spacing(
                              props.theme.tokens.spacing.none,
                              props.theme.tokens.spacing.none,
                              props.theme.tokens.spacing.none,
                              props.theme.tokens.spacing.xs
                          )
                        : props.theme.spacing(
                              props.theme.tokens.spacing.xxs,
                              props.theme.tokens.spacing.none,
                              props.theme.tokens.spacing.none
                          ),
                },
            },
        ],
    },
};
